import { MAIN_STEPS } from "../constants/constants";
import { DMQ_STEP_FLOW } from "./formStorage";

const STEP_FLOW_KEY = DMQ_STEP_FLOW;

export const buildStepFlow = (isUserNRI, isUserFN, isUserDiabetic, isUserBloodPresure, isUserThyroid, isUserKidney) => {
  const steps = [
    {
      id: MAIN_STEPS.PERSONAL_DETAILS,
      title: "Personal Details",
      internalSteps: 2,
    },
    {
      id: MAIN_STEPS.MEDICAL_HISTORY,
      title: "Medical History",
      internalSteps: 3,
    },
  ];

  if (isUserNRI) {
    steps.push({
      id: MAIN_STEPS.NRI_QUESTIONNAIRE,
      title: "NRI Questionnaire",
      internalSteps: 0,
    });
  }

  if (isUserFN) {
    steps.push({
      id: MAIN_STEPS.FOREIGN_NATIONAL_QUESTIONNAIRE,
      title: "Foreign National Questionnaire",
      internalSteps: 0,
    });
  }

  if (isUserDiabetic) {
    steps.push({
      id: MAIN_STEPS.DIABETIC_QUESTIONNAIRE,
      title: "Diabetes Questionnaire",
      internalSteps: 0,
    });
  }

  if (isUserBloodPresure) {
    steps.push({
      id: MAIN_STEPS.BLOOD_PRESSURE_QUESTIONNAIRE,
      title: "High BP Questionnaire",
      internalSteps: 0,
    });
  }

  if (isUserThyroid) {
    steps.push({
      id: MAIN_STEPS.THYROID_QUESTIONNAIRE,
      title: "Thyroid Questionnaire",
      internalSteps: 0,
    });
  }

  if (isUserKidney) {
    steps.push({
      id: MAIN_STEPS.KIDNEY_QUESTIONNAIRE,
      title: "Kidney Questionnaire",
      internalSteps: 0,
    });
  }

  steps.push({
    id: MAIN_STEPS.CONFIRM_DETAILS,
    title: "Confirm Details",
    internalSteps: 0,
  });

  localStorage.setItem(STEP_FLOW_KEY, JSON.stringify(steps));

  return steps;
};

export const getStepFlow = () => {
  const data = localStorage.getItem(STEP_FLOW_KEY);
  return data ? JSON.parse(data) : [];
};
